// ONYX – Sticky-Bar aus dem Section-Wrapper an den body hängen (Fix für fixed-in-transform)
(function () {
  const bar = document.getElementById('sticky-cart-bar');
  if (bar && bar.parentElement !== document.body) {
    document.body.appendChild(bar);
  }
})();


// ONYX – globale Scroll-Reveal-Animationen
(function () {
  function initReveals() {
    const els = document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach((el) => el.classList.add('active'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    els.forEach((el) => observer.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveals);
  } else {
    initReveals();
  }
})();


// ONYX – Fakten: komplette Kachel flappt (Zahl, Einheit, Label) wie eine Abflugtafel
(function () {
  const items = document.querySelectorAll('.specs-grid .spec-item.has-flap');
  if (!items.length) return;

  const interval  = 80;
  const baseFlaps = 26;
  const LETTERS   = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const reduced   = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const scramble = (str, pool) =>
    str.replace(/[^\s.,:;!?()\-]/g, () => pool[Math.floor(Math.random() * pool.length)]);
  const randNum = () => {
    const d = Math.random() < 0.4 ? 3 : (Math.random() < 0.7 ? 2 : 1);
    return Math.floor(Math.random() * Math.pow(10, d));
  };

  function run() {
    items.forEach((item, i) => {
      const num   = item.querySelector('.spec-flap');
      const unit  = item.querySelector('.unit');
      const label = item.querySelector('.spec-label');
      const fin = {
        num:   num   ? (num.dataset.flapTarget || '0') : '',
        unit:  unit  ? unit.textContent  : '',
        label: label ? label.textContent : '',
      };
      const tNum = baseFlaps + i * 15, tUnit = tNum + 4, tLabel = tNum + 9;

      const settle = () => {
        if (num)   num.textContent   = fin.num;
        if (unit)  unit.textContent  = fin.unit;
        if (label) label.textContent = fin.label;
        item.classList.remove('flapping');
        item.classList.add('settled');
      };
      if (reduced) { settle(); return; }

      item.classList.add('flapping');
      let n = 0;
      const timer = setInterval(() => {
        n++;
        if (num)   num.textContent   = n < tNum   ? randNum()                          : fin.num;
        if (unit)  unit.textContent  = n < tUnit  ? scramble(fin.unit, LETTERS + '%+0') : fin.unit;
        if (label) label.textContent = n < tLabel ? scramble(fin.label, LETTERS)        : fin.label;
        if (n >= tLabel) { clearInterval(timer); settle(); }
      }, interval);
    });
  }

  const grid = items[0].closest('.specs-grid');
  const obs = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) { run(); obs.unobserve(grid); }
    });
  }, { threshold: 0.4 });
  obs.observe(grid);
})();


// ONYX – FAQ Accordion
(function () {
  document.querySelectorAll('.faq-question').forEach((btn) => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const isOpen = item.classList.contains('active');

      document.querySelectorAll('.faq-item').forEach((i) => {
        i.classList.remove('active');
        i.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        item.classList.add('active');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
})();


// ONYX – Custom Cursor (Desktop only)
(function () {
  if (window.matchMedia('(max-width: 768px)').matches) return;

  const ring = document.createElement('div');
  ring.className = 'cursor';
  const dot = document.createElement('div');
  dot.className = 'cursor-dot';
  document.body.appendChild(ring);
  document.body.appendChild(dot);

  let mouseX = 0, mouseY = 0, ringX = 0, ringY = 0;

  document.addEventListener('mousemove', (e) => {
    mouseX = e.clientX; mouseY = e.clientY;
    dot.style.left = mouseX + 'px';
    dot.style.top = mouseY + 'px';
  });

  function animate() {
    ringX += (mouseX - ringX) * 0.15;
    ringY += (mouseY - ringY) * 0.15;
    ring.style.left = ringX + 'px';
    ring.style.top = ringY + 'px';
    requestAnimationFrame(animate);
  }
  animate();

  document.querySelectorAll('a, button, .variant-option').forEach((el) => {
    el.addEventListener('mouseenter', () => ring.classList.add('hover'));
    el.addEventListener('mouseleave', () => ring.classList.remove('hover'));
  });
})();


// ONYX – Preloader (1x pro Session)
(function () {
  const pre = document.getElementById('preloader');
  if (!pre) return;
  if (sessionStorage.getItem('onyx_loaded')) { pre.remove(); return; }

  const bar = document.getElementById('preloader-progress');
  let p = 0;
  const timer = setInterval(() => {
    p += Math.random() * 30;
    if (p >= 100) {
      p = 100;
      clearInterval(timer);
      setTimeout(() => {
        pre.classList.add('hidden');
        sessionStorage.setItem('onyx_loaded', '1');
        setTimeout(() => pre.remove(), 600);
      }, 200);
    }
    bar.style.width = p + '%';
  }, 150);
})();


// ONYX – Sticky Cart Bar (2-Achsen: Edition-Chips + Pegel-Pills, eigenständig + synced)
(function () {
  const bar = document.getElementById('sticky-cart-bar');
  if (!bar) return;

  const product   = document.getElementById('product');
  const priceEl   = bar.querySelector('.sticky-cart-price');
  const qInfo     = bar.querySelector('[data-scb-quickinfo]');
  const buyBtn    = document.getElementById('sticky-cart-btn');
  const buyLabel  = buyBtn && buyBtn.querySelector('.scb-btn-label');
  const defLabel  = buyLabel ? buyLabel.textContent : 'Add to Setup';
  const cartBadge = document.getElementById('scb-cart-badge');
  const shipWrap  = bar.querySelector('[data-scb-freeship]');
  const shipFill  = bar.querySelector('[data-scb-fill]');
  const shipLabel = bar.querySelector('[data-scb-shiplabel]');
  const threshold = parseInt(bar.dataset.freeShip, 10) || 0;
  const addedNext = document.querySelector('[data-added-next]');

  const editionChips = [...bar.querySelectorAll('[data-edition]')];
  const pegelPills    = [...bar.querySelectorAll('[data-ausf]')];
  const singleEl      = bar.querySelector('[data-scb-single]');

  const varsEl   = bar.querySelector('[data-scb-variants]');
  const variants = varsEl ? JSON.parse(varsEl.textContent) : [];

  let skEdition = bar.dataset.initEdition || (variants[0] && variants[0].option1) || null;
  let skAusf    = bar.dataset.initAusf    || (variants[0] && variants[0].option2) || null;
  let currentId = bar.dataset.initialVariant ? Number(bar.dataset.initialVariant)
                                             : (singleEl ? Number(singleEl.dataset.variantId)
                                                         : (variants[0] && variants[0].id));
  let inView = false;

  const money = (c) => (window.Shopify && Shopify.formatMoney)
    ? Shopify.formatMoney(c, window.moneyFormat)
    : '€' + (c / 100).toFixed(2).replace('.', ',');
  const findVar = (o1, o2) => variants.find(v => v.option1 === o1 && (o2 == null || v.option2 === o2));

  // --- Sichtbarkeit ---
  function updateBar() {
    const scrolled = window.scrollY > (product ? 800 : 300);
    bar.classList.toggle('show', scrolled && !inView);
  }
  if (product) {
    new IntersectionObserver((e) => { inView = e[0].isIntersecting; updateBar(); }, { threshold: 0.3 }).observe(product);
  }
  window.addEventListener('scroll', updateBar, { passive: true });

  // --- Zustand → UI spiegeln ---
  function resolve() {
    const v = findVar(skEdition, skAusf) || findVar(skEdition, null) || variants[0];
    if (!v) return;
    currentId = v.id;
    if (priceEl) priceEl.textContent = money(v.price);

    editionChips.forEach(c => {
      const on = c.dataset.edition === skEdition;
      c.classList.toggle('active', on);
      c.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    pegelPills.forEach(p => {
      const combo = findVar(skEdition, p.dataset.ausf);
      const on = p.dataset.ausf === skAusf;
      p.classList.toggle('active', on);
      p.setAttribute('aria-checked', on ? 'true' : 'false');
      const sold = !combo || !combo.available;
      p.classList.toggle('sold-out', sold);
      p.toggleAttribute('disabled', sold);
    });

    if (buyBtn) {
      buyBtn.disabled = !v.available;
      if (buyLabel) buyLabel.textContent = v.available ? defLabel : 'Ausverkauft';
    }
  }

  function dispatchSelect() {
    document.dispatchEvent(new CustomEvent('onyx:external-select', {
      detail: { edition: skEdition, ausf: skAusf, source: 'sticky' }
    }));
  }

  // --- Interaktion ---
  editionChips.forEach(c => {
    c.addEventListener('click', () => {
      if (c.disabled) return;
      skEdition = c.dataset.edition; resolve(); dispatchSelect();
    });
    c.addEventListener('mouseenter', () => {
      if (qInfo && c.dataset.blurb) { qInfo.textContent = c.dataset.blurb; qInfo.hidden = false; }
    });
    c.addEventListener('mouseleave', () => { if (qInfo) qInfo.hidden = true; });
  });
  pegelPills.forEach(p => {
    p.addEventListener('click', () => {
      if (p.disabled) return;
      skAusf = p.dataset.ausf; resolve(); dispatchSelect();
    });
  });

  // --- Product-Form → Sticky (Echo, kein Re-Dispatch = kein Loop) ---
  document.addEventListener('onyx:variant-changed', (e) => {
    const d = e.detail || {};
    if (d.source === 'sticky') return;
    let ch = false;
    if (d.edition != null && d.edition !== skEdition) { skEdition = d.edition; ch = true; }
    if (d.ausf    != null && d.ausf    !== skAusf)    { skAusf    = d.ausf;    ch = true; }
    if (ch) resolve();
    else { if (d.id) currentId = d.id; if (priceEl && d.price != null) priceEl.textContent = money(d.price); }
  });

  // --- Kaufen ---
  async function addDirect(variantId) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
    });
    if (!res.ok) throw new Error('add failed');
    const cart = await (await fetch('/cart.js')).json();
    document.dispatchEvent(new CustomEvent('onyx:cart-updated', { detail: { count: cart.item_count } }));
  }
  function triggerAdd() {
    const mainAdd = document.querySelector('[data-add-btn]'); // Product-Form ist synchron
    if (mainAdd) { mainAdd.click(); return; }
    if (currentId) addDirect(currentId).catch(() => {});
  }
  if (buyBtn) buyBtn.addEventListener('click', triggerAdd);

  // --- Free-Shipping + Badge ---
  function renderShip(totalCents) {
    if (!shipWrap || threshold <= 0) return;
    shipWrap.hidden = false;
    if (shipFill) shipFill.style.width = Math.min((totalCents / threshold) * 100, 100) + '%';
    if (shipLabel) shipLabel.textContent = totalCents >= threshold
      ? '🎉 Gratisversand erreicht'
      : `Noch ${money(threshold - totalCents)} bis Gratisversand`;
  }
  async function refreshCart() {
    try {
      const cart = await (await fetch('/cart.js')).json();
      renderShip(cart.total_price);
      if (cartBadge) { cartBadge.textContent = cart.item_count; cartBadge.hidden = cart.item_count === 0; }
      if (addedNext) addedNext.hidden = cart.item_count === 0;
      updateBar();
    } catch (e) {}
  }

  // --- Nach Add: Feedback ---
  document.addEventListener('onyx:cart-updated', (e) => {
    if (buyBtn) {
      buyBtn.classList.add('added');
      if (buyLabel) buyLabel.textContent = '✓ Hinzugefügt';
      setTimeout(() => { buyBtn.classList.remove('added'); if (buyLabel) buyLabel.textContent = defLabel; }, 1500);
    }
    if (addedNext) addedNext.hidden = false;
    refreshCart();

    const c = e.detail && e.detail.count;
    const cc = document.getElementById('cart-count');
    const cb = document.getElementById('cart-badge');
    if (cc) cc.textContent = c;
    if (cb) { cb.textContent = c; cb.classList.toggle('show', c > 0); }
  });

  // --- Upsell (einmalig pro Session) ---
  const upsell = bar.querySelector('[data-scb-upsell]');
  if (upsell) {
    const addExtra = upsell.querySelector('[data-scb-upsell-add]');
    const skip = upsell.querySelector('[data-scb-upsell-skip]');
    const done = () => { upsell.hidden = true; sessionStorage.setItem('onyx_upsell_done', '1'); bar.classList.remove('expanded'); };
    document.addEventListener('onyx:cart-updated', () => {
      if (!upsell.dataset.shown && !sessionStorage.getItem('onyx_upsell_done')) {
        upsell.hidden = false; upsell.dataset.shown = '1'; bar.classList.add('expanded');
      }
    });
    if (addExtra) addExtra.addEventListener('click', () => { triggerAdd(); done(); });
    if (skip) skip.addEventListener('click', done);
  }

  // --- Einklappen (persistiert, respektiert User-Entscheidung) ---
  const collapseToggle = bar.querySelector('[data-scb-toggle]');
  const COLLAPSE_KEY = 'onyx_scb_collapsed';
  if (localStorage.getItem(COLLAPSE_KEY) === '1') {
    bar.classList.add('collapsed');
    if (collapseToggle) collapseToggle.setAttribute('aria-expanded', 'false');
  }
  if (collapseToggle) collapseToggle.addEventListener('click', () => {
    const c = bar.classList.toggle('collapsed');
    collapseToggle.setAttribute('aria-expanded', c ? 'false' : 'true');
    localStorage.setItem(COLLAPSE_KEY, c ? '1' : '0');
  });

  resolve();
  refreshCart();
})();


// ONYX – Age Gate (18+)
(function () {
  const gate = document.getElementById('age-gate');
  if (!gate) return;

  if (localStorage.getItem('onyx_age_ok')) {
    gate.classList.add('hidden');
    document.documentElement.classList.remove('age-pending');
    return;
  }

  document.body.style.overflow = 'hidden';

  const yes = document.getElementById('age-gate-yes');
  if (yes) yes.addEventListener('click', () => {
    localStorage.setItem('onyx_age_ok', '1');
    gate.classList.add('hidden');
    document.body.style.overflow = '';
    document.documentElement.classList.remove('age-pending'); // Banner erscheint jetzt – genau einmal
    if (window.onyxRevealNicht) window.onyxRevealNicht();
  });
})();


// ONYX – Notfall-Overlay (Multi-Screen)
(function () {
  const btn = document.getElementById('emergency-btn');
  const overlay = document.getElementById('emergency-overlay');
  const closeBtn = document.getElementById('emergency-close');
  const bar = document.getElementById('sticky-cart-bar');
  if (!btn || !overlay) return;

  const screens = overlay.querySelectorAll('.em-screen');
  function show(n) {
    screens.forEach((s) => s.classList.toggle('active', s.dataset.screen === String(n)));
  }
  function open() {
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    show(1);
  }
  function close() {
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  btn.addEventListener('click', open);
  closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.classList.contains('active')) close();
  });

  overlay.querySelectorAll('[data-goto]').forEach((el) => {
    el.addEventListener('click', () => show(el.dataset.goto));
  });

  if (bar) {
    new MutationObserver(() => {
      document.body.classList.toggle('cart-bar-visible', bar.classList.contains('show'));
    }).observe(bar, { attributes: true, attributeFilter: ['class'] });
  }
})();


// ONYX – Manifest: Zensur-Balken langsam & gestaffelt enthüllen
(function () {
  const el = document.getElementById('manifest-reveal');
  if (!el) return;
  const bars = el.querySelectorAll('.mr-bar');
  bars.forEach((bar, i) => { bar.style.transitionDelay = (1.9 + i * 0.9) + 's'; });
  const obs = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) { el.classList.add('revealed'); obs.unobserve(el); }
    });
  }, { threshold: 0.4 });
  obs.observe(el);
})();


// ONYX – Hero "Nicht." (wird ausgelöst, wenn der Vorhang fällt)
(function () {
  const el = document.getElementById('hero-nicht');
  if (!el) return;
  window.onyxRevealNicht = function () {
    if (!el.classList.contains('show')) setTimeout(() => el.classList.add('show'), 450);
  };
  const gate = document.getElementById('age-gate');
  const gateActive = gate && !localStorage.getItem('onyx_age_ok');
  if (!gateActive) setTimeout(window.onyxRevealNicht, 900);
})();


// ONYX – Datenblatt: Karten gestaffelt einblenden (mit Fallback)
(function () {
  const cards = document.querySelectorAll('.ds-card');
  if (!cards.length) return;

  const failsafe = setTimeout(() => {
    cards.forEach((c) => c.classList.add('drawn'));
  }, 2500);

  if (!('IntersectionObserver' in window)) {
    cards.forEach((c) => c.classList.add('drawn'));
    clearTimeout(failsafe);
    return;
  }

  const obs = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const card = entry.target;
        const i = [...cards].indexOf(card);
        setTimeout(() => card.classList.add('drawn'), i * 200);
        obs.unobserve(card);
      }
    });
  }, { threshold: 0.15 });

  cards.forEach((c) => obs.observe(c));
})();


// ONYX – Duell: rechte Seite gestaffelt aufleuchten (Delays per JS)
(function () {
  const grid = document.getElementById('duel-grid');
  if (!grid) return;
  const ons = grid.querySelectorAll('.duel-on');
  ons.forEach((el, i) => { el.style.transitionDelay = (i * 0.92) + 's'; });

  const obs = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) { grid.classList.add('lit'); obs.unobserve(grid); }
    });
  }, { threshold: 0.3 });
  obs.observe(grid);
})();


// ONYX – Hausregeln: entschleunigt nacheinander enthüllen
(function () {
  const list = document.getElementById('rules-list');
  if (!list) return;
  const rows = list.querySelectorAll('.rule-row');
  rows.forEach((row, i) => { row.style.transitionDelay = (i * 0.35) + 's'; });
  const obs = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) { list.classList.add('revealed'); obs.unobserve(list); }
    });
  }, { threshold: 0.3 });
  obs.observe(list);
})();


// ONYX – Formulare ohne Reload (Newsletter + Kontakt), captcha-tolerant
// Ablauf: Honeypot prüfen → fetch → Antwort-HTML auf Erfolg/Fehler parsen → sonst echter Submit (Captcha-Flow)
(function () {
  const forms = document.querySelectorAll('form[data-onyx-ajax]');
  if (!forms.length) return;

  // Bestätigungsseite /account/subscribe: Shopify-Systemseite → stylen + Text ersetzen
  if (location.pathname.startsWith('/account/subscribe')) {
    document.body.classList.add('onyx-subscribe');
    const main = document.querySelector('main') || document.body;
    const h1 = main.querySelector('h1');
    const p  = main.querySelector('p');
    const a  = main.querySelector('a[href*="unsubscribe"], a');
    if (h1) h1.textContent = 'Drin.';
    if (p)  p.textContent  = 'Du hörst von uns – selten, aber dann lohnt es sich. Bis dahin: Funkstille.';
    if (a)  a.textContent  = 'Doch nicht? Hier raus.';
  }

  forms.forEach((form) => {
    const kind = form.dataset.onyxAjax;
    const successEl = document.querySelector(kind === 'contact' ? '[data-ct-success]' : '[data-nl-success]');
    const errorEl   = document.querySelector(kind === 'contact' ? '[data-ct-error]'   : '[data-nl-error]');
    const summary   = document.querySelector('[data-ct-summary]');
    let bypass = false;

    form.addEventListener('submit', async (e) => {
      if (bypass) return;                                   // echter Submit → Shopify-Captcha darf greifen
      e.preventDefault();

      const hp = form.querySelector('[name="contact[website]"]');
      if (hp && hp.value) { form.hidden = true; if (successEl) successEl.hidden = false; return; }  // Bot: still schlucken

      const btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      if (errorEl) errorEl.hidden = true;

      // Zusammenfassung VOR dem Absenden einsammeln
      if (summary) {
        summary.innerHTML = '';
        form.querySelectorAll('[data-sum]').forEach((f) => {
          if (!f.value.trim()) return;
          const dt = document.createElement('dt'); dt.textContent = f.dataset.sum;
          const dd = document.createElement('dd'); dd.textContent = f.value.trim();
          summary.append(dt, dd);
        });
      }

      try {
        const res  = await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' }, redirect: 'follow' });
        const html = await res.text();
        const doc  = new DOMParser().parseFromString(html, 'text/html');

        const ok = res.url.includes('posted=true')
          || doc.querySelector('[data-nl-server-success]')
          || (kind === 'contact' && doc.querySelector('.form-success:not([data-ct-success])'));
        const err = doc.querySelector('[data-nl-server-error], .form-error:not([data-ct-error])');

        if (ok)  { form.hidden = true; if (successEl) successEl.hidden = false; return; }
        if (err) { if (errorEl) errorEl.hidden = false; if (btn) btn.disabled = false; return; }
      } catch (_) {}

      // Captcha aktiv oder Unbekanntes → normaler Submit mit Event (Shopify-Script injiziert Token)
      bypass = true;
      if (btn) btn.disabled = false;
      form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  });
})();



// ONYX – Kontakt: Eingaben merken, nach Reload als Zusammenfassung zeigen
(function () {
  const form = document.getElementById('contact-form');
  if (form) {
    form.addEventListener('submit', () => {
      const fd = new FormData(form);
      sessionStorage.setItem('onyx_contact', JSON.stringify({
        email: fd.get('contact[email]') || '',
        order: fd.get('contact[Bestellnummer]') || '',
        body:  fd.get('contact[body]') || '',
      }));
    });
  }
  const box = document.querySelector('[data-contact-summary]');
  if (!box) return;
  try {
    const d = JSON.parse(sessionStorage.getItem('onyx_contact') || 'null');
    if (!d) return;
    box.querySelectorAll('[data-sum]').forEach((el) => { el.textContent = d[el.dataset.sum] || '–'; });
    box.hidden = false;
    sessionStorage.removeItem('onyx_contact');
  } catch (e) {}
})();


// ONYX – hCaptcha-Challenge: Shopify-Text durch unseren ersetzen
(function () {
  const msg = document.querySelector('.shopify-challenge__message');
  const btn = document.querySelector('.shopify-challenge__button');
  if (!msg) return;
  msg.innerHTML = 'Bist Du echt?<small>Kein Vorwurf. Wir fragen jeden. Bots kriegen bei uns keinen Newsletter.</small>';
  if (btn) btn.textContent = 'Ja, echt.';
})();


// ONYX – 404: Flapboard-Code, zufällige Zeile, Pfad-Spiegel, Notfall-Shortcut
(function () {
  const sec = document.getElementById('not-found');
  if (!sec) return;

  // Zufällige Zeile
  try {
    const lines = JSON.parse(sec.querySelector('[data-nf-lines]').textContent);
    const el = sec.querySelector('[data-nf-line]');
    if (lines.length && el) el.textContent = lines[Math.floor(Math.random() * lines.length)];
  } catch (e) {}

  // Pfad spiegeln (nur harmlose Zeichen, gekürzt)
  const path = decodeURIComponent(location.pathname).replace(/[^\w\-\/äöüÄÖÜß.]/g, '').slice(0, 48);
  const pWrap = sec.querySelector('[data-nf-path]');
  const pCode = sec.querySelector('[data-nf-path-code]');
  if (path && path !== '/' && pWrap && pCode) { pCode.textContent = path; pWrap.hidden = false; }

  // Flapboard 4-0-4
  const flaps = sec.querySelectorAll('.nf-flap');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  flaps.forEach((f, i) => {
    const target = f.dataset.nfTarget;
    if (reduced) { f.textContent = target; f.classList.add('settled'); return; }
    const total = 14 + i * 7;
    let n = 0;
    f.classList.add('flapping');
    const t = setInterval(() => {
      if (++n >= total) { clearInterval(t); f.textContent = target; f.classList.remove('flapping'); f.classList.add('settled'); }
      else f.textContent = Math.floor(Math.random() * 10);
    }, 70);
  });

  // Notfall-Button der Seite auslösen
  const em = sec.querySelector('[data-nf-emergency]');
  const headerBtn = document.getElementById('emergency-btn');
  if (em && headerBtn) em.addEventListener('click', () => headerBtn.click());
  else if (em) em.addEventListener('click', () => { location.href = '/pages/get-help'; });
})();


